<template>
  <div class="m-editCont">
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    content: {
      default: ""
    }
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
.m-editCont {
  color: #333;
  padding: 15px 0;
  .ql-container {
    font-size: 14px;
    &.ql-snow {
      border: 0;
    }
  }
  .ql-editor {
    padding: 0;
    line-height: 1.5;
  }
  strong {
    font-size: inherit;
  }
}
</style>
